module.exports = __webpack_public_path__ + "img/header-bg.bbea358b.jpg";